module.exports = __webpack_public_path__ + "media/images/lp_v6_mv_pict02_pc02-29af1ecb1e1d1c7774d5ee92eecaad4b.webp";